/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Type_ChangeInputs */

const en_case_type_change = /** @type {(inputs: Case_Type_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change type`)
};

const pt_br2_case_type_change = /** @type {(inputs: Case_Type_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar tipo`)
};

/**
* | output |
* | --- |
* | "Change type" |
*
* @param {Case_Type_ChangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_type_change = /** @type {((inputs?: Case_Type_ChangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Type_ChangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_type_change(inputs)
	return pt_br2_case_type_change(inputs)
});